// extracted by mini-css-extract-plugin
export default {"stack":"Header_stack__Rokeo"};